import axios from "axios";
import { buildTokenJWT, Encrypt, getOptions } from "./serviceEncrypt";
import { generateLegacyID } from "../utils/utils";

export async function getJsonOffersPorta() {
  const cacheName = "offers-cache";
  const cacheUrl = `${process.env.PUBLIC_URL}/data/offersDetailsPortaLN_v32.json`;

  // Comprueba si hay una versión en caché del archivo JSON
  const cache = await caches.open(cacheName);
  // const cachedResponse = await cache.match(cacheUrl);

  // if (cachedResponse) {
  // Si hay una versión en caché, devuélvela
  //   return cachedResponse.json();
  // }

  // Si no hay una versión en caché, realiza la solicitud y guarda el resultado en caché
  const response = await axios.get(cacheUrl);
  const responseData = response.data;
  cache.put(cacheUrl, new Response(JSON.stringify(responseData)));

  return responseData;
}

export async function getJsonShop() {
  const shopUrl = `${process.env.PUBLIC_URL}/data/ceActive_v1.json`;
  const response = await axios.get(shopUrl);
  const responseData = response.data;
  return responseData;
}

export async function postRequest(path, data) {
  let dateStamp = Date.now();
  let tokenJWT = await buildTokenJWT(dateStamp);
  let options = await getOptions(tokenJWT);
  return axios.post(
    `${process.env.REACT_APP_CAPTACION}/${path}`,
    data,
    options
  );
}

export async function servicePost(data, path) {
  let dataEncrypt = Encrypt(data);
  return await postRequest(path, dataEncrypt);
}

export async function servicePostSession(serviceRequest, SessionID, path) {
  let dataEncrypt = Encrypt(serviceRequest);
  let data = JSON.stringify({
    serviceNumber: dataEncrypt,
    sessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function customerInfoById(dataPage, path, SessionID) {
  let data = JSON.stringify({
    IdType: Encrypt(dataPage.idType),
    ServiceNumber: Encrypt(dataPage.idNumber),
    SessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function stockReservation(data, path) {
  let fullstackOrderNumberEncrypt = Encrypt(data.fullstackOrderNumber);
  let warehouseIdEncrypt = Encrypt(data.warehouseId);
  let materialNumberEncrypt = Encrypt(data.materialNumber);
  let dataToSend = {
    fullstackOrderNumber: fullstackOrderNumberEncrypt,
    warehouseId: warehouseIdEncrypt,
    materialNumber: materialNumberEncrypt,
    sessionID: data.sessionID,
  };
  return await postRequest(path, dataToSend);
}

export async function verifyAddressService(
  departmentBizCode,
  cityBizCode,
  street,
  complement,
  completeAddress,
  SessionID,
  path
) {
  let departmentBizCodeEncrypt = Encrypt(departmentBizCode);
  let cityBizCodeEncrypt = Encrypt(cityBizCode);
  let fullAddress = completeAddress
    ? completeAddress
    : `${street} ${complement}`;
  let fullAddressEncrypt = Encrypt(fullAddress);
  let data = JSON.stringify({
    StateOrProvinceGeographicAddress: departmentBizCodeEncrypt,
    TownIdGeographicAddress: cityBizCodeEncrypt,
    FormattedRespAddressSubsidy: fullAddressEncrypt,
    SessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function logisticArrivalTimeService(
  departmentRegionCode,
  municipalityRegionCode,
  SessionID,
  path
) {
  let departmentRegionCodeEncrypt = Encrypt(departmentRegionCode);
  let municipalityRegionCodeEncrypt = Encrypt(municipalityRegionCode);
  let deliveryTypeEncrypt = Encrypt("Normal");
  let data = JSON.stringify({
    DePartment: departmentRegionCodeEncrypt,
    MuniCipality: municipalityRegionCodeEncrypt,
    DeliveryType: deliveryTypeEncrypt,
    SessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function validatePCOService(dataPage, path, SessionID) {
  const offer = {
    offerId: Encrypt(dataPage.idOffer),
    offerName: Encrypt(dataPage.offerName),
    offerPrice: Encrypt(dataPage.offerPrice),
  };

  const user = {
    idType: Encrypt(dataPage.idType),
    idNumber: Encrypt(dataPage.idNumber),
    effectiveTime: Encrypt(dataPage.effectiveTime),
    lastName: Encrypt(dataPage.lastName),
    birthday: Encrypt(dataPage.birthday),
  };

  const commonData = {
    offer,
    user,
    legacyID: generateLegacyID(),
    SessionID: SessionID,
  };

  const data = JSON.stringify({ ...commonData });

  return await postRequest(path, data);
}

export async function wareHouseListNService(busiList, sessionID, path) {
  return await postRequest(path, {
    busiHallIds: busiList,
    SessionID: sessionID,
  });
}

export async function inventoryStockService(
  wareHouseIds,
  sessionID,
  skuCode,
  path
) {
  let simSkuCodeEncrypt = Encrypt(skuCode);
  let data = JSON.stringify({
    warehouseIds: wareHouseIds,
    simSkuCode: simSkuCodeEncrypt,
    SessionID: sessionID,
  });
  return await postRequest(path, data);
}

export async function regionListService(regionId, SessionID, path) {
  let regionIdEncrypt = Encrypt(regionId);
  let data = JSON.stringify({
    regionId: regionIdEncrypt,
    SessionID: SessionID,
  });

  let dateStamp = Date.now();
  let tokenJWT = await buildTokenJWT(dateStamp);
  let options = await getOptions(tokenJWT);
  return axios.post(
    `https://prepago.movistar.co/captacion-back/${path}`,
    data,
    options
  );
}

export async function createOrderService(createOrderRequest, path) {
  createOrderRequest.offerId = Encrypt(createOrderRequest.offerId);
  createOrderRequest.user.homeAddress.addr9 = Encrypt(
    createOrderRequest.user.homeAddress.addr9
  );
  return await postRequest(path, createOrderRequest);
}

export async function createAbandonedCartService(
  createAbandonedCartRequest,
  path
) {
  const paymentDataString = JSON.stringify(
    createAbandonedCartRequest.cartData.paymentData
  );
  createAbandonedCartRequest.cartData.invoice = Encrypt(
    createAbandonedCartRequest.cartData.invoice
  );
  createAbandonedCartRequest.cartData.paymentData = Encrypt(paymentDataString);
  createAbandonedCartRequest.cartData.orderNumber = Encrypt(
    createAbandonedCartRequest.cartData.orderNumber
  );
  createAbandonedCartRequest.cartData.lineNumber = Encrypt(
    createAbandonedCartRequest.cartData.lineNumber
  );
  createAbandonedCartRequest.cartData.purchaseType = Encrypt(
    createAbandonedCartRequest.cartData.purchaseType
  );
  createAbandonedCartRequest.cartData.simType = Encrypt(
    createAbandonedCartRequest.cartData.simType
  );
  createAbandonedCartRequest.cartData.commerce = Encrypt(createAbandonedCartRequest.cartData.commerce);
  return await postRequest(path, createAbandonedCartRequest);
}

/**
 * Servicio datos para homologacion de los canales , extra2 a extra5
 */
export async function getJsonHomologation() {
  return await axios.get(`${process.env.PUBLIC_URL}/data/homologation.json`);
}

// Servicio que consulta el estado de la transacción en ePayco
export async function getPaymentValidation(refEpayco) {
  try {
    const response = await fetch(
      `https://secure.epayco.co/validation/v1/reference/` + refEpayco
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error al consultar la transacción:", error);
    return { success: false, error: error.message };
  }
}

/**
 * Servicio para enviar encuesta de inactividad
 */
export async function submitInactivitySurvey(surveyData) {
  try {
    const { phoneNumber, hasApproved, comments, sessionId } = surveyData;

    // Encriptar los datos sensibles
    const encryptedPhoneNumber = Encrypt(phoneNumber || "");

    const data = {
      phoneNumber: encryptedPhoneNumber,
      hasApproved: hasApproved,
      comments: comments,
      surveyType: "Portabilidad",
      sessionId: sessionId,
    };

    let dateStamp = Date.now();
    let tokenJWT = await buildTokenJWT(dateStamp);
    let options = await getOptions(tokenJWT);

    const response = await axios.post(
      `${process.env.REACT_APP_CAPTACION}/SurveyFeedback/createSurveyFeedback`,
      data,
      options
    );

    return { success: true, data: response.data };
  } catch (error) {
    console.error("Error al enviar la encuesta de inactividad:", error);
    const errorMessage = error.response ? error.response.data : error.message;
    return { success: false, error: errorMessage };
  }
}

export async function getAbandonedCartByNumber(
  phoneNumber
) {
  try {
    const dateStamp = Date.now();

    const [tokenJWT, phoneEncrypt] = await Promise.all([
      buildTokenJWT(dateStamp),
      Encrypt(phoneNumber),
    ]);
    const options = await getOptions(tokenJWT);

    const { data } = await axios.post(
      `${process.env.REACT_APP_CAPTACION}/AbandonedCarts/getAbandonedCartByNumber`,
      { serviceNumber: phoneEncrypt, SessionID: dateStamp.toString() },
      options
    );

    /* ---------------- Parseos ---------------- */
    const paymentDataRaw = JSON.parse(data.paymentData);
    const extra10Obj =
      typeof paymentDataRaw.extra10 === "string"
        ? JSON.parse(paymentDataRaw.extra10)
        : paymentDataRaw.extra10;

    const cart = {
      ...data,
      paymentData: { ...paymentDataRaw, extra10: extra10Obj },
    };

    return cart;
  } catch (err) {
    console.error("❌ Error al obtener carrito abandonado", err);
    return null;
  }
}

export async function sendCashPaymentEmail(
  payload
) {
  // Puedes crear una interfaz para la respuesta si lo deseas
  try {
    const dateStamp = Date.now();
    const tokenJWT = await buildTokenJWT(dateStamp);
    const options = await getOptions(tokenJWT);

    // 1. Encriptar todos los campos requeridos por el backend en paralelo
    const [receiverNameEnc, receiverEnc, offerPriceEnc, refEpaycoEnc] =
      await Promise.all([
        Encrypt(payload.receiverName),
        Encrypt(payload.receiver),
        Encrypt(payload.offerPrice),
        Encrypt(payload.refEpayco),
      ]);

    // 2. Construir el cuerpo de la petición con los datos encriptados
    const requestBody = {
      SessionID: dateStamp.toString(),
      ReceiverName: receiverNameEnc,
      Receiver: receiverEnc,
      OfferPrice: offerPriceEnc,
      RefEpayco: refEpaycoEnc,
    };

    // 3. Llamar al nuevo endpoint
    //    Asegúrate de reemplazar 'NombreDeTuControlador' si es necesario.
    const url = `${process.env.REACT_APP_CAPTACION}/transversalorder/sendCashPaymentEmail`;

    const { data } = await axios.post(url, requestBody, options);

    console.log("✅ Correo de pago en efectivo enviado exitosamente", data);
    return data; // Retorna la respuesta del backend (ej: { resCode: "0", resMsg: "successful" })
  } catch (err) {
    console.error("❌ Error al enviar el correo de pago en efectivo", err);
    return null; // O puedes lanzar el error, según tu manejo preferido
  }
}

export async function stock(dataPage, path, SessionID) {
  let data = JSON.stringify({
    skuCode: Encrypt(dataPage.skuCode),
    itemTypeId: Encrypt(dataPage.itemTypeId),
    sessionId: SessionID,
  });
  return await postRequest(path, data);
}

export async function cancelStockEsim(bookID, path, SessionID) {
  let bookIDEncrypt = Encrypt(bookID);
  let data = JSON.stringify({
    BookID: bookIDEncrypt,
    SessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function cancelStockSim(FullstackOrderNumber, ReservationNumber, path, SessionID) {
  let FullstackOrderNumberEncrypt = Encrypt(FullstackOrderNumber);
  let ReservationNumberEncrypt = Encrypt(ReservationNumber);
  let data = JSON.stringify({
    FullstackOrderNumber: FullstackOrderNumberEncrypt,
    ReservationNumber: ReservationNumberEncrypt,
    SessionID: SessionID,
  });
  return await postRequest(path, data);
}

export async function sendEmailEsim(dataPage, path, SessionID) {
  let data = JSON.stringify({
    Receiver: Encrypt(dataPage.email),
    ReceiverName: Encrypt(dataPage.name),
    PortaDate: Encrypt(dataPage.changeDate),
    OfferPrice: Encrypt(dataPage.totalAmount),
    OfferDescription: Encrypt("Plan eSIM"),
    RefEpayco: Encrypt(dataPage.refEpayco),
    sessionId: SessionID,
  });
  return await postRequest(path, data);
}

export async function postReferidoTendero(data, sessionID) {
  let dataToSend = {
    codigoTendero: Encrypt(data.codigoTendero),
    tipoOperacion: Encrypt(data.tipoOperacion),
    nombres: Encrypt(data.nombres),
    apellidos: Encrypt(data.apellidos),
    telefono: Encrypt(data.telefono),
    dispositivo: Encrypt(data.dispositivo),
    sessionId: sessionID,
  };
  return await postRequest("tenderos/guardarReferido", dataToSend);
}